import { render, staticRenderFns } from "./PageBackground.vue?vue&type=template&id=327d9eb0&scoped=true&"
import script from "./PageBackground.vue?vue&type=script&lang=js&"
export * from "./PageBackground.vue?vue&type=script&lang=js&"
import style0 from "./PageBackground.vue?vue&type=style&index=0&id=327d9eb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327d9eb0",
  null
  
)

export default component.exports